import React, { useEffect, useState } from 'react';
import { fetchRamasProfesionales, RamaProfesional } from '../../services/ramaProfesionalService';

interface Props {
    cargo: string;
    onCargoChange: (value: string) => void;
    perfilPublico: boolean;
    onPerfilPublicoChange: (value: boolean) => void;
}

export default function ProfessionalProfileFields({ cargo, onCargoChange, perfilPublico, onPerfilPublicoChange }: Props) {
    const [ramas, setRamas] = useState<RamaProfesional[]>([]);
    const [rama, setRama] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        fetchRamasProfesionales().then(data => {
            if (active) setRamas(data);
        }).catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, []);

    const detected = ramas.find(item => item.subramas?.some(sub => sub.toLowerCase() === cargo.trim().toLowerCase()));
    const selected = ramas.find(item => item.codigo === (rama || detected?.codigo));

    return (
        <div style={{ gridColumn: '1 / -1', minWidth: 0 }}>
            <label htmlFor="profile-professional-area">Área profesional</label>
            <select id="profile-professional-area" className="pl-input" value={rama || detected?.codigo || ''} onChange={e => setRama(e.target.value)}>
                <option value="">Selecciona tu área</option>
                {ramas.map(item => <option key={item.codigo} value={item.codigo}>{item.nombre}</option>)}
            </select>
            {error && <p role="status">No se pudieron cargar las áreas. Puedes escribir tu ocupación.</p>}
            {selected && <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, margin: '12px 0' }}>
                {(selected.subramas || []).map(sub => <button key={sub} type="button" className="pl-btn-ghost" onClick={() => onCargoChange(sub.slice(0, 100))}>{sub}</button>)}
            </div>}
            <label htmlFor="profile-profession">Cargo, ocupación o especialidad</label>
            <input id="profile-profession" className="pl-input" value={cargo} maxLength={100} onChange={e => onCargoChange(e.target.value)} placeholder="Ej.: Arquitecto, Contador, Desarrollador" />
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, margin: '16px 0' }}>
                <input type="checkbox" checked={perfilPublico} onChange={e => onPerfilPublicoChange(e.target.checked)} />
                <span>Autorizo mostrar mi nombre, ocupación y foto en el Banco de Profesionales. Mi correo, teléfono y documentos permanecen privados. Puedo retirar esta autorización guardando mi perfil.</span>
            </label>
        </div>
    );
}
